import Utils from '../../../scripts/vendors/utils';

/**
 * Cookie Consent
 *
 * Usage via global event listener:
 * window.addEventListener('app.cookieConsent.onChange', function(event) {
 *   console.log('The cookie consent has been updated.', app.cookies.cookieConsent.types);
 * });
 *
 * Usage via statement:
 * if (app.cookies.cookieConsent.types.external) { … }
 *
 * Open the cookie consent layer via a link with the hashtag "#cookie-consent":
 * <a href="#cookie-consent">Open Cookie Consent</a>
 *
 * @class
 * @constructor
 * @public
 */
class cookieConsent {
  /**
   * Constructor
   * @returns {class}
   */
  constructor() {
    !app.cookies && console.error('Application: window.app.cookies object required.');

    this.cookieConsent = document.getElementById('cookie-consent--js');

    if (!this.cookieConsent || !app.cookies.cookieConsent) {
      return;
    }

    // Parameters
    this.saveButtons = this.cookieConsent.querySelectorAll('#cookie-consent-save, a');
    this.acceptButton = document.getElementById('cookie-consent-accept');
    this.openTrigger = document.querySelectorAll('[href="#cookie-consent"]');

    // Engage engines
    this.init();
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init() {
    if (Utils.cookie.get(app.cookies.cookieConsent.name)) {
      app.cookies.cookieConsent.types = JSON.parse(Utils.cookie.get(app.cookies.cookieConsent.name));
      this.fireCustomEvent();
    } else {
      app.cookies.cookieConsent.types = {};
      this.openCookieConsent();
    }

    this.addEventListeners();

    return this;
  }

  addEventListeners() {
    this.saveButtons.forEach(saveButton => {
      saveButton.addEventListener('click', this.onSaveButtonClick.bind(this))
    })
    this.acceptButton.addEventListener('click', this.onAcceptButtonClick.bind(this));
    this.openTrigger.forEach(trigger => {
      trigger.addEventListener('click', this.onOpenTrigger.bind(this))
    })
  }

  onSaveButtonClick(event) {
    this.setCookieConsent();
    this.closeCookieConsent();
  }

  onAcceptButtonClick(event) {
    this.setCookieConsent('all' /* Select all checkboxes */);
    this.closeCookieConsent();
  }

  onOpenTrigger(event) {
    event.preventDefault();
    this.openCookieConsent();
  }

  openCookieConsent() {
    this.cookieConsent.classList.add('is-active');
    this.cookieConsent.setAttribute('aria-hidden', 'false');

    this.updateCheckboxes('update');
  }

  closeCookieConsent() {
    this.cookieConsent.classList.remove('is-active');
    this.cookieConsent.setAttribute('aria-hidden', 'true');
  }

  fireCustomEvent() {
    window.dispatchEvent(new CustomEvent('app.cookieConsent.onChange'));
  }

  setCookieConsent(selectCheckboxes) {
    this.updateCheckboxes(selectCheckboxes);
    this.fireCustomEvent();

    // Set cookie
    Utils.cookie.set(
      app.cookies.cookieConsent.name,
      JSON.stringify(app.cookies.cookieConsent.types),
      app.cookies.cookieConsent.expires,
      app.cookies.cookieConsent.path
    );
  }

  updateCheckboxes(selectCheckboxes) {
    let form = this.cookieConsent;

    for (let i = 0; i < form.elements.length; i++ ) {
      if (form.elements[i].type == 'checkbox') {
        if (selectCheckboxes == 'all') {
          form.elements[i].checked = true;
        }

        // Populate checkboxes
        if (selectCheckboxes == 'update' && !form.elements[i].disabled) {
          form.elements[i].checked = app.cookies.cookieConsent.types[form.elements[i].value];
        }

        // Store values
        app.cookies.cookieConsent.types[form.elements[i].value] = form.elements[i].checked;
      }
    }
  }

  /**
   * Class name
   * @returns {string} The human readable class name
   */
  get name() {
    return 'cookieConsent';
  }
};

module.exports = cookieConsent;
